import {Component, Input} from '@angular/core';
import {PROFILE_STATE} from '../../../../../../common/constants';

@Component({
    selector: 'tfl-bo-profile-state-badge',
    template: `
        <span [ngClass]="stateBadgeClass">
            {{ stateBadgeTitle | translate }}
        </span>
    `
})
export class ProfileStateBadgeComponent {

    stateBadgeClass: any = {};
    stateBadgeTitle: string = '';

    @Input('state')
    set _state(state: string) {
        this.stateBadgeClass = this.getStateBadgeClass(state);
        this.stateBadgeTitle = this.getStateBadgeTitle(state);
    }

    private getStateBadgeClass(state: string): any {
        return {
            'label        ': true,
            'label-success': state === PROFILE_STATE.ACTIVE,
            'label-danger': state === PROFILE_STATE.REJECTED || state === PROFILE_STATE.DECLINED || state === PROFILE_STATE.SUSPENDED || state === PROFILE_STATE.CLOSED,
            'label-default': state === PROFILE_STATE.NEW,
            'label-info   ': state === PROFILE_STATE.ON_HOLD,
            'label-warning': state === PROFILE_STATE.PROCESSING,
            'btn-dark'   : state === PROFILE_STATE.ARCHIVED,
        };
    }

    private getStateBadgeTitle(state: string): string {
        switch (state) {
            case PROFILE_STATE.ACTIVE:
                return 'CUSTOMER.STATE.ACTIVE';
            case PROFILE_STATE.REJECTED:
                return 'CUSTOMER.STATE.REJECTED';
            case PROFILE_STATE.DECLINED:
                return 'CUSTOMER.STATE.DECLINED';
            case PROFILE_STATE.NEW:
                return 'CUSTOMER.STATE.NEW';
            case PROFILE_STATE.PROCESSING:
                return 'CUSTOMER.STATE.PROCESSING';
            case PROFILE_STATE.ARCHIVED:
                return 'CUSTOMER.STATE.ARCHIVED';
            case PROFILE_STATE.ON_HOLD:
                return 'CUSTOMER.STATE.ON_HOLD';
            case PROFILE_STATE.SUSPENDED:
                return 'CUSTOMER.STATE.SUSPENDED';
            case PROFILE_STATE.CLOSED:
                return 'CUSTOMER.STATE.CLOSED';
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/profile.state.badge.component.ts